import UserListTemplate from "app/features/userRoles/users/templates/UserListTemplate";

export default function UserScreen() {
  return <UserListTemplate />;
}
